'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { TVideoContent, videoContentAtom } from './VideoContentState'
import { VideoScreen } from './VideoScreen'

export const VideoLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TVideoContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[videoContentAtom, content],
	])

	return <VideoScreen previewMode={false} demoMode={false} />
}
